import { loadingSpinner, errorPopup, successPopup, formatTimestamp, refreshTooltips, auditLink } from "./utils.js";
import { prettyAddress } from "./ethereum/utils.js";
import { providerInit, onWalletConnect, getSigner, isConnected } from "./ethereum/wallet.js";
import CompliantContractAbi from "./ethereum/contracts/abis/compliant-contract.js";
import ComplianceAbi from "./ethereum/contracts/abis/compliance.js";
const ethers = require('ethers');

async function fetchPendingUsersApproval() {
    const signer = await getSigner();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const dappId = $('#dapp-address-input').val();
    $('#fetch-pending-users-approval').html(loadingSpinner);
    $('#pending-users-approval-table').hide();
    try {
        const pendingUsers = await getPendingUsersApproval(chainId, dappId);
        successPopup('Pending users fetched successfully');
        $('#pending-users-approval-list').empty();
        $('#pending-users-approval-table').show();
        for (const [user, status] of Object.entries(pendingUsers)) {
            const statusCell = status != 'pending' ? status : `
                <span id="verdict-${user}">
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="verdict-button-${user}-approve"
                        onclick="setUserApproval('${chainId}', '${dappId}', '${user}', 'approved')">
                        Approve
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        class="btn btn-danger"
                        id="verdict-button-${user}-reject"
                        onclick="setUserApproval('${chainId}', '${dappId}', '${user}', 'rejected')">
                        Reject
                    </button>
                </span>`;
            $('#pending-users-approval-list').append(
                `<tr>
                    <td>${user}</td>
                    <td>${statusCell}</td>
                </tr>`);
        }
    } catch (error) {
        errorPopup(error);
    }
    $('#fetch-pending-users-approval').text('Fetch users');
}

async function buildApprovalsTable() {
    const signer = await getSigner();
    const chainId = (await signer.provider.getNetwork()).chainId;
    const dappAddress = $('#dapp-address-input').val();
    const dapp = new ethers.Contract(dappAddress, CompliantContractAbi, signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new ethers.Contract(complianceAddress, ComplianceAbi, signer);
    const approvalsPromise = compliance.queryFilter(compliance.filters.ApprovalRequired(dappAddress));
    const approvals = (await approvalsPromise).reverse();
    if (approvals.length == 0) {
        $('#approvals').hide();
        return;
    }
    for (var i = 0; i < approvals.length; i++) {
        const approval = approvals[i];
        const { fullHash } = approval.args;
        approval.complianceConsumedPromise = compliance.queryFilter(compliance.filters.ComplianceConsumed(dappAddress, fullHash));
        approval.complianceConsumed = (await approval.complianceConsumedPromise).length > 0;
        if (approval.complianceConsumed)
            continue;
        approval.complianceDetailsPromise = compliance.queryFilter(compliance.filters.ComplianceRegistered(dappAddress, fullHash));
        approval.complianceVerdictPromise = compliance.queryFilter(compliance.filters.ComplianceVerdict(dappAddress, fullHash));
        approval.blockPromise = signer.provider.getBlock(approval.blockNumber);
    }
    for (var i = 0; i < approvals.length; i++) {
        const approval = approvals[i];
        if (approval.complianceConsumed)
            continue;
        approval.complianceVerdict = (await approval.complianceVerdictPromise);
        approval.verdictBlockPromise =
            approval.complianceVerdict.length == 0
            ? null
            : signer.provider.getBlock(approval.complianceVerdict[0].blockNumber);
    }
    for (var i = 0; i < approvals.length; i++) {
        const approval = approvals[i];
        if (approval.complianceConsumed)
            continue;
        approval.complianceDetails = (await approval.complianceDetailsPromise)[0].args.complianceDetails;
        approval.timestamp = (await approval.blockPromise).timestamp;
        approval.verdictTimestamp = approval.verdictBlockPromise === null ? null : (await approval.verdictBlockPromise).timestamp;
    }
    $('#approvals-table').empty();
    for (var i = 0; i < approvals.length; i++) {
        const approval = approvals[i];
        if (approval.complianceConsumed)
            continue;
        console.log("approval", approval);
        const { fullHash, partialHash } = approval.args;
        var richArgs = `All: ${fullHash}<br />`;
        for (var j = 0; j < approval.complianceDetails.length; j++) {
            const comSubData = approval.complianceDetails[j];
            richArgs += `${comSubData.complianceType} [${comSubData.providerName}]${comSubData.ref?': ':''}${auditLink(chainId, comSubData.ref)}<br />`;
        }
        approval.state =
            approval.complianceVerdict.length > 0
            ? `${approval.complianceVerdict[0].args.approved ? 'Approved' : 'Rejected'} on ${formatTimestamp(Number(approval.verdictTimestamp))}`
            : `
                <span id="verdict-${partialHash}">
                    <button
                        type="button"
                        class="btn btn-primary"
                        id="verdict-button-${partialHash}-approve">
                        Approve
                    </button>
                    &nbsp;
                    <button
                        type="button"
                        class="btn btn-danger"
                        id="verdict-button-${partialHash}-reject">
                        Reject
                    </button>
                </span>
            `;
        $('#approvals-table').append(`<tr>
            <td>${formatTimestamp(Number(approval.timestamp))}</td>
            <td>${richArgs}</td>
            <td>${approval.state}</td>
        </tr>`);
        $(`#verdict-button-${partialHash}-approve`).on('click', function() { issueVerdict(partialHash, true); });
        $(`#verdict-button-${partialHash}-reject`).on('click', function() { issueVerdict(partialHash, false); });
    }
}

async function connectDapp(autoConnect=false) {
    const dappAddress = $('#dapp-address-input').val();
    const prettyDappAddress = prettyAddress(dappAddress);
    if (prettyDappAddress === dappAddress) {
        errorPopup('Invalid Dapp address');
        return;
    }
    const signer = await getSigner();
    const signerAddress = await signer.getAddress();
    const dapp = new ethers.Contract(dappAddress, CompliantContractAbi, signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new ethers.Contract(complianceAddress, ComplianceAbi, signer);
    const controller_role = await compliance.CONTROLLER_ROLE();
    const signerIsController = await compliance.hasRole(controller_role, signerAddress);
    if (!signerIsController) {
        errorPopup('You are not a registered controller of this Dapp');
        return;
    }
    $('#dapp-address').html(prettyDappAddress);
    refreshTooltips();
    if (!autoConnect)
        successPopup('Dapp connected successfully');

    $('#dapp-connected-false').hide();
    $('#dapp-connected-true').show();
    $('.require-dapp-connected-true').show();
    await buildApprovalsTable();
}

async function issueVerdict(partialHash, approved) {
    const dappAddress = $('#dapp-address-input').val();
    const clickedSelector = approved ? `#verdict-button-${partialHash}-approve` : `#verdict-button-${partialHash}-reject`;
    $(`#verdict-button-${partialHash}-approve`).prop('disabled', true);
    $(`#verdict-button-${partialHash}-reject`).prop('disabled', true);
    $(clickedSelector).html(loadingSpinner);
    const signer = await getSigner();
    const dapp = new ethers.Contract(dappAddress, CompliantContractAbi, signer);
    const complianceAddress = await dapp.compliance();
    const compliance = new ethers.Contract(complianceAddress, ComplianceAbi, signer);
    try {
        await compliance.issueVerdict(dappAddress, partialHash, approved);
    } catch (error) {
        errorPopup(error.message);
        $(`#verdict-button-${partialHash}-approve`).prop('disabled', false);
        $(`#verdict-button-${partialHash}-reject`).prop('disabled', false);
        $(clickedSelector).html(approved ? 'Approve' : 'Reject');
        return;
    }
    $(`#verdict-${partialHash}`).html(`${approved ? 'Approved' : 'Rejected'} just now`);
}

onWalletConnect(async () => {
    if ($('#dapp-address-input').val())
        connectDapp(true);
});

$(document).ready(function() {
    const searchParams = new URLSearchParams(window.location.search);
    providerInit(searchParams.has('wallet') ? searchParams.get('wallet') : 'metamask');
    if (searchParams.has('dapp'))
        $('#dapp-address-input').val(searchParams.get('dapp'));
    $('#connect-dapp-form').on('submit', function(e) {
        e.preventDefault();
        connectDapp();
    });
    $('#fetch-pending-users-approval-form').on('submit', function(e) {
        e.preventDefault();
        fetchPendingUsersApproval();
    });
    if (isConnected && $('#dapp-address-input').val())
        connectDapp(true);
});
